'use client';

import { ColumnDef } from '@tanstack/react-table';

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export type FileKnowledgeItem = {
  id: string;
  title: string;
  category: string;
  type: string;
  created_at: string;
};

export const fileKnowledgeColumns: ColumnDef<FileKnowledgeItem>[] = [
  {
    accessorKey: 'title',
    header: 'Título',
    size: 250,
    cell: function TitleCell({ row }: { row: { original: FileKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[180px]">
          {row.original.title}
        </div>
      );
    },
  },
  {
    accessorKey: 'category',
    header: 'Categoria',
    size: 150,
    cell: function CategoryCell({ row }: { row: { original: FileKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[120px]">
          {row.original.category || '-'}
        </div>
      );
    },
  },
  {
    accessorKey: 'type',
    header: 'Tipo',
    size: 150,
    cell: function TypeCell({ row }: { row: { original: FileKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[120px]">
          {row.original.type || '-'}
        </div>
      );
    },
  },
  {
    accessorKey: 'created_at',
    header: 'Criado em',
    size: 180,
    cell: function CreatedAtCell({ row }: { row: { original: FileKnowledgeItem } }) {
      return (
        <div className="whitespace-normal break-words w-[160px]">
          {formatDate(row.original.created_at)}
        </div>
      );
    },
  },
];
